import { VirtualCardAPI } from '@apis'
import { createAuthenticatedLoader, useLoaderId } from '@utils/loaders'
import { buildDemoGroup } from './demo-data'

export const groupRouteId = 'group'

export const loader = createAuthenticatedLoader(({ params }, Clerk) => {
    if (params.groupId === 'demo') return buildDemoGroup(Clerk.user?.id)
    return VirtualCardAPI.GetGroupRequest.fetch(params.groupId)
})

export const useGroupLoaderData = () => useLoaderId<typeof loader>(groupRouteId)
